"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INCORRECT_PHONE_ERROR_MESSAGE = void 0;
const INCORRECT_PHONE_ERROR_MESSAGE = exports.INCORRECT_PHONE_ERROR_MESSAGE = 'Указан некорректный номер телефона. Проверьте правильность ввода';